import { Component } from '@angular/core';
import { PlanService } from 'src/app/services/plan.service';
import { PlanListModel } from '../plan-list';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/services/translation.service';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';

@Component({
    selector: 'app-plans-reminders',
    templateUrl: './plans-reminders.component.html',
    styleUrls: ['./plans-reminders.component.scss'],
    standalone: false
})

export class PlansRemindersComponent {

  plans: PlanListModel[] = [];
  activePlans: PlanListModel[] = [];
  completedPlans: PlanListModel[] = [];
  translations: any;
  participantClassByRole: string = '';

  constructor(private _planservice: PlanService,
    private router: Router,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService)
  { }

  ngOnInit(): void {
    this._planservice.getParticipantPlans().subscribe({
      next: (data) => {
        this.plans = data;
        this.activePlans = this.plans.filter(x => x.planStatus == "active");
        this.completedPlans = this.plans.filter(x => x.planStatus != "active");
      }
    });

    this.translationservice.getTranslation().subscribe({
      next: (data) => {
        this.translations=data;
      }
    });

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
  }

  navigate(url: string) {
    this.router.navigateByUrl(url);
  }

}
